import swal from 'sweetalert';

let msgAlertService = {};

// Default msg swal
msgAlertService.swal = function (title, msg, type) {
  swal({
    title: title,
    text: msg,
    button: "Confirmar",
    icon: type
  });
};

// Default msg error
msgAlertService.defaultError = function() {
  swal({
    title: "Ops...",
    text: "Olá, tivemos um problema! \n\n Por favor, aguarde alguns minutos para tentar novamente ou consulte a equipe de suporte.",
    button: "Confirmar",
    icon: 'error'
  });
};

// Msg error when searching
msgAlertService.searchError = function() {
  swal({
    title: "Ops...",
    text: "Erro na pesquisa! \n Por favor, confirme os dados que você utilizou na pesquisa.",
    button: "Confirmar",
    icon: 'error'
  });
}

// Show msg error from array
msgAlertService.showMsgError = function(reason) {
  if (reason) {
    if (reason.length) {
      let msgError = '';
      reason.erros.map((value, index) => {
        msgError += value + '\n';

        if (reason.length === index + 1) {
          swal({
            title: "Ops...",
            text: msgError,
            button: "Confirmar",
            icon: 'error'
          });
        }
      });
    } else {
      msgAlertService.defaultError();
    }
  } else {
    msgAlertService.defaultError();
  }
};

export const ALERT_SERVICE = msgAlertService;



// WEBPACK FOOTER //
// ./src/msgAlertService.js